module.exports = __webpack_public_path__ + "img/40.25cac15.jpg";